module.exports = __webpack_public_path__ + "static/media/icon.a47c7f83.png";